import { computed } from 'mobx';
import { observer } from 'mobx-react';
import { autoinject, bind, CardItem, Enums, inject, ModalHandle, removeUnderscores, StatusCard } from 'Mri.Web.Common';
import * as React from 'react';
import { LinkedManifestModal } from '../../../SoftwareUpdates/LinkedManifestModal';
import { ActiveDisplay } from '../../ActiveDisplay';
import { DisplaysStore } from '../../DisplaysStore';

export interface IDisplaySoftwareVersionsCardProps {
    readonly loading?: boolean;
    readonly display: ActiveDisplay;
}

@autoinject
@observer
export class DisplaySoftwareVersionsCard extends React.Component<IDisplaySoftwareVersionsCardProps> {
    public render() {
        return (
            <StatusCard title={this.renderTitle()} loading={this.props.loading}>
                {this.softwareVersions?.map((v, idx) => (
                    <CardItem
                        key={idx}
                        label={v.fsType ? removeUnderscores(Enums.toString(Enums.FileSystemType, v.fsType)) : 'Unknown'}
                        value={
                            <span>
                                {v.productType}.{v.majorRevision}.{v.minorRevision}
                                {v.buildRevision > 0 && `-${v.buildRevision}`}{' '}
                                {Enums.toString(Enums.FileSystemBuildType, v.buildType)}
                            </span>
                        }
                    />
                ))}
            </StatusCard>
        );
    }

    @bind
    private renderTitle() {
        return (
            <div>
                Software Versions
                {this.displayUpdateStatus?.linkedSoftwareUpdateManifests && (
                    <a className="btn btn-primary float-end px-2" onClick={this.openLinkedManifestsModal}>
                        Active Linked Manifests
                    </a>
                )}
                {this.displayUpdateStatus?.linkedSoftwareUpdateManifests && (
                    <LinkedManifestModal
                        displaySerial={this.props.display.serialNumber}
                        modalHandle={this.linkedManifestsModal}
                    />
                )}
            </div>
        );
    }

    @bind
    private openLinkedManifestsModal() {
        this.linkedManifestsModal.open();
    }

    @computed
    private get softwareVersions() {
        return this.displaysStore.softwareVersions.get(this.props.display.serialNumber);
    }

    @computed
    private get displayUpdateStatus() {
        return this.displaysStore.updateStatuses.get(this.props.display.serialNumber);
    }

    private linkedManifestsModal = new ModalHandle();
    @inject
    private displaysStore!: DisplaysStore;
}
